import { FormItem } from '@magicdoorinc/form';
import { LabeledTextInput, useLocalization } from '@magicdoorinc/ui';
import type { Component } from 'solid-js';

export type DriverLicenseInputProps = {
  pathPrefix?: (string | number)[];
  requireNumber?: boolean;
};

const joinPath = (prefix: (string | number)[], ...rest: string[]): (string | number)[] => [...prefix, ...rest];

export const DriverLicenseInput: Component<DriverLicenseInputProps> = (props) => {
  const { t } = useLocalization();
  const prefix = () => props.pathPrefix ?? [];

  return (
    <>
      <FormItem
        label={t("Driver's license number")}
        placeholder={t("Driver's license number")}
        formFieldName={joinPath(prefix(), 'driversLicense', 'number')}
        component={LabeledTextInput}
        rules={
          props.requireNumber
            ? [
                { required: true, message: t('{name} is required', { name: t("Driver's license number") }) },
                {
                  validator: (value: string) =>
                    typeof value === 'string' && value.trim().length > 0
                      ? true
                      : t('{name} is required', { name: t("Driver's license number") }),
                },
              ]
            : undefined
        }
      />
      <FormItem
        rules={[
          { required: props.requireNumber === true, message: t('{name} is required', { name: t("Driver's license state") }) },
          { length: 2, message: t('{name} must be {length} characters', { name: t("Driver's license state"), length: 2 }) },
        ]}
        label={t("Driver's license state")}
        placeholder={t("Driver's license state")}
        formFieldName={joinPath(prefix(), 'driversLicense', 'state')}
        component={LabeledTextInput}
      />
    </>
  );
};
